// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__afiCF","benefits":"styles_benefits__i3UGn","benefit":"styles_benefit__QlDBz"};